export const PATH_PREFIX_COOKIE = 'mzhpathprefix';



// WEBPACK FOOTER //
// ./src/constants.js